
import $ from '@/fly'

export default {
    data () {
        return {
            list: [],
            detail: null,
            pageNum: 1,
            search: '',
            typePollutants: ''
        };
    },
    methods: {
        // 获取问题组件返回的值
        questionVal (val) {
            this.typePollutants = val.typePollutants
        },
        // 获取字典列表
        getdicttype () {
            return $.get('dict/type', {
                type: 'pollutants_type',
                pageSize: 15,
                pageNum: this.pageNum,
                param: this.search
            })
        },
        // 获取字典列表
        getdictgas () {
            return $.get('dict/type', {
                type: 'gas_main_category',
                pageSize: 299,
                pageNum: this.pageNum,
                param: this.search
            })
        },
        // 获取标准库
        getLibrary () {
            return $.get('standard-library', {
                pageSize: 199,
                pageNum: this.pageNum,
                standardDocumentNumberAndName: this.search
            })
        },
        // 验证手机号格式
        validPhone (phone) {
            if (!/^1[34578]\d{9}$/.test(phone)) {
                return '手机号格式不正确'
            }
            return true
        },
        // 生成随机数
        rand (min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
        // 一维数组去重
        unique (arr) {
            var hash = [];
            for (var i = 0; i < arr.length; i++) {
                if (hash.indexOf(arr[i]) === -1) {
                    hash.push(arr[i]);
                }
            }
            return hash;
        },
        // Object去重
        ObjectUnique (arr) {
            if (!arr) return null;
            var resultArr = [];
            arr.forEach((el) => {
                var notExist = true;
                resultArr.forEach((element) => {
                    if (this.isObjectValueEqual(el, element)) {
                        notExist = false;
                        return false;
                    }
                });
                if (notExist) {
                    resultArr.push(el);
                }
            });
            return resultArr;
        },
        // 判断两个 Object 的值是否相等
        isObjectValueEqual (a, b) {
            var aProps = Object.values(a);
            var bProps = Object.values(b);
            if (aProps.length !== bProps.length) {
                return false;
            }
            if (JSON.stringify(aProps.sort()) !== JSON.stringify(bProps.sort())) {
                return false
            }
            return true;
        }
    }
};
